import axios from './_nestAxios'

export const getSede = _id => axios.get(`/sedes/${_id}`)

export const nuevaSede = data => axios.post('/sedes', data)
export const actualizarSede = (_id, data) => axios.put(`/sedes/${_id}`, data)
export const eliminarSede = _id => axios.delete(`/sedes/${_id}`)

export const getSerie = _idSerie => axios.get(`/sedes/series/${_idSerie}`)
export const nuevaSerie = data => axios.post(`/sedes/series`, data)
export const actualizarSerie = (_idSerie, data) => axios.put(`/sedes/series/${_idSerie}`, data)
export const eliminarSerie = _idSerie => axios.delete(`/sedes/series/${_idSerie}`)

export const obtenerAsSelect = () =>
  axios.get('/sedes', {
    params: {
      tipoConsulta: 'select'
    }
  })

export const obtenerExceptoActual = () =>
  axios.get('/sedes', {
    params: {
      tipoConsulta: 'select',
      exceptoActual: 'true'
    }
  })

export const obtenerSeriexSedexTipoSerie = ({ tipoSerie }) =>
  axios.get('/sedes/series', {
    params: { tipoSerie, tipoConsulta: 'select' }
  })

export const obtenerSeriesInfoxSede = () =>
  axios.get('/sedes/series', {
    params: { tipoConsulta: 'select-completo' }
  })
